export default __webpack_public_path__ + "static/media/19.9842daa1.jpg";